import styled from "styled-components"

const UnityDropdownLabel = styled.label`
  font-family: Noto;
  font-size: 12px;
  color: #5f6368;
`

export default UnityDropdownLabel
